/* Footer GET DIRECTIONS: prefer Apple Maps on Apple devices.

   Progressive enhancement only. Each directions link's href is already
   a working Google Maps directions URL (built in sections/footer.liquid
   from the location block's own address fields), so without this file -
   or on Android / Windows / anything else - the link simply opens Google
   Maps. On Apple platforms, the Apple Maps URL from data-apple-maps-href
   is swapped in at click time, just before the browser follows the link.

   Apple detection is deliberately tiny: User-Agent Client Hints where
   available (Chromium browsers report "macOS"/"iOS"), otherwise the
   classic user-agent string. iPadOS reports itself as "Macintosh", which
   the same pattern already covers. No location permission is requested -
   the maps app picks the customer's starting point itself. */
(function () {
  function isApplePlatform() {
    var uaData = navigator.userAgentData;
    if (uaData && uaData.platform) return /^(macOS|iOS)$/i.test(uaData.platform);
    return /iPhone|iPad|iPod|Macintosh/i.test(navigator.userAgent || '');
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[data-apple-maps-href]');
    if (!link || !isApplePlatform()) return;
    link.href = link.getAttribute('data-apple-maps-href');
  });
})();
